var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.salesPitchDto.title
        ? _c("header-signature", {
            staticClass: "pb-1",
            attrs: { text: _vm.salesPitchDto.title },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.salesPitchDto.pitches, function (pitch, index) {
          return _c("div", { key: index, staticClass: "col-12 col-md-4" }, [
            pitch
              ? _c("div", [
                  _c("div", {
                    staticClass: "h4 mb-auto",
                    domProps: { innerHTML: _vm._s(pitch.title) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "alert-container ps-0" }, [
                    _c(
                      "p",
                      {
                        staticClass: "alert ob1-alert-normal align-items-start",
                      },
                      [
                        _c("span", {
                          staticClass: "alert-icon pitch-icon",
                          class: [pitch.iconName],
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "ob1-alert-title text-gray3",
                          domProps: {
                            innerHTML: _vm._s(pitch.descriptionHtml),
                          },
                        }),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }